"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Export = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Export = function (props) {
    return (React.createElement(sok_ui_1.Button, { iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-file-chart-line' }), size: props.size, color: 'blue', disabled: props.disabled, className: 'text-left', text: (0, translation_1.getLocalization)('management/reports/exportDropDown'), onClick: props.onClick }));
};
exports.Export = Export;
